export default class StompConfig {
    static create(actualStompConfig){
        return {
            brokerURL:actualStompConfig.brokerURL,
            heartbeatIncoming: actualStompConfig.heartbeatIncoming,
            heartbeatOutgoing: actualStompConfig.heartbeatOutgoing,
            connectionTimeout:  actualStompConfig.connectionTimeout,
            reconnectDelay: actualStompConfig.reconnectDelay,
        }
    }
    static equals(stompConfig_1, stompConfig_2){
        // works, so long as objects created with the create function
        return JSON.stringify(stompConfig_1) === JSON.stringify(stompConfig_2);
    }
}